import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Function to check if the device is mobile
function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

console.log(isMobileDevice(), "dfsdfdsfsdfsfsfsdfdsfsdf")
if (isMobileDevice()) {
    // Display a message or redirect if on a mobile device
    document.body.innerHTML = "<h1>Access from mobile devices is prohibited. Please log in from a desktop environment.</h1>";
} else {
    ReactDOM.render(<App />, document.getElementById('root'));
    serviceWorker.unregister();
}
